import React, { useState, useEffect } from 'react';
import { useDashboardData } from 'dsoa-components';
import { Link } from 'react-router-dom';
import { Button } from 'semantic-ui-react';
import { loggedIn, NextGatherInfoUrl } from 'dsoa-components';
import { coursesByAbbreviations, courseCanEnroll, courseEnroll } from 'dsoapi';

const CoursesAvailableForEnrollment = ({ courseAbbrs }) => {
  const [enrolling, setEnrolling] = useState({});
  const [allCourseInfo, setAllCourseInfo] = useState([]);

  const dashboardData = useDashboardData();

  useEffect(() => {
    const fetchAllCourseInfo = async () => {
      const res = await coursesByAbbreviations({ abbreviations: courseAbbrs });
      setAllCourseInfo(res.data || []);
    };
    fetchAllCourseInfo();
  }, [courseAbbrs]);

  const handleEnroll = async (abbreviation) => {
    if (!loggedIn()) {
      localStorage.setItem('signupCourse', abbreviation);
      window.location.href = '/signup';
      return;
    }
    if (enrolling[abbreviation]) return;
    setEnrolling((prev) => ({ ...prev, [abbreviation]: true }));
    const canEnrollRes = await courseCanEnroll(abbreviation);
    if (canEnrollRes.data.canEnroll) {
      const enrollRes = await courseEnroll(abbreviation, {
        siteRegisteredWith: 'fedsafe',
      });
      const url = await NextGatherInfoUrl(
        enrollRes.data.userCourseEnrollmentId
      );
      window.location.href = url;
    } else {
      setEnrolling((prev) => ({ ...prev, [abbreviation]: false }));
      window.location.href = '/dashboard';
    }
  };

  const getCourseInfo = (abbr) =>
    allCourseInfo.find((c) => c.abbreviation === abbr) || {};

  if (dashboardData.activeTab !== 'REGISTER') {
    return null;
  }

  return (
    <div className="ui segment">
      <h3 className="ui header" style={{ textAlign: 'center' }}>
        Courses Available for Enrollment
      </h3>
      <div className="ui divider"></div>
      <div className="ui divided items">
        {(() => {
          const regCourses = Array.isArray(dashboardData.registrationInProgress)
            ? dashboardData.registrationInProgress
            : [];
          const enrolledCourses = Array.isArray(dashboardData.enrolled)
            ? dashboardData.enrolled
            : [];

          const excludeAbbrs = [...regCourses, ...enrolledCourses]
            .map((c) => c && (c.abbreviation || c.courseAbbreviation || c.code))
            .filter(
              (abbr) => abbr !== undefined && abbr !== null && abbr !== ''
            );

          const excludeSet = new Set(
            excludeAbbrs.map((abbr) => String(abbr).trim().toUpperCase())
          );

          const filteredCourses = courseAbbrs.filter((abbr) => {
            const abbrNorm = String(abbr).trim().toUpperCase();
            return !excludeSet.has(abbrNorm);
          });

          return filteredCourses.map((abbr) => {
            const info = getCourseInfo(abbr);
            return (
              <div className="item" key={abbr}>
                <div className="content">
                  <div className="header">
                    {info.displayName || info.title || abbr}
                  </div>
                  <div className="meta">
                    {info.price && (
                      <span>Price: ${parseFloat(info.price).toFixed(2)}</span>
                    )}
                  </div>
                  <div className="extra">
                    <Button
                      primary
                      onClick={() => handleEnroll(abbr)}
                      loading={!!enrolling[abbr]}
                      disabled={!!enrolling[abbr]}
                    >
                      {enrolling[abbr] ? 'Enrolling...' : 'Enroll Now'}
                    </Button>
                    <Button
                      as={Link}
                      to={`/course/${abbr}`}
                      style={{ marginLeft: 8 }}
                    >
                      Learn More
                    </Button>
                  </div>
                </div>
              </div>
            );
          });
        })()}
      </div>
    </div>
  );
};

export default CoursesAvailableForEnrollment;
